import React, { Component } from 'react'
import Workspace from '../components/Workspace'
import { connect } from 'react-redux'
import { bootApplication } from 'actions'
import Loader from 'ui/Loader'

class WorkspaceApp extends Component {
  render () {
    if (this.props.isBooting) return <Loader isLoading />
    return <Workspace {...this.props} />
  }

  componentDidMount () {
    this.props.onMount()
  }
}

function mapStateToProps (state, ownProps) {
  const { name, isBooting } = state.application.page

  return {
    currentPage: name,
    isBooting
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onMount: workspaceSlug => dispatch(bootApplication(ownProps.params.workspaceSlug))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceApp)



// WEBPACK FOOTER //
// ./containers/WorkspaceApp.js